module.exports = __webpack_public_path__ + "src/assets/img/bradesco.621bfa4c.svg";